import { object, string, boolean } from "yup";

export default ({ intl, isSportEvent }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return isSportEvent
    ? {
        matchPointConfig: object()
          .shape({
            ocurrencesSource: string().nullable(),
            ocurrencesSourceId: string()
              .nullable()
              .when("ocurrencesSource", {
                is: ocurrencesSource => !!ocurrencesSource,
                then: id => id.required(requiredText),
              }),
            ocurrencesVisible: boolean().nullable(),
          })
          .required(requiredText),
      }
    : {};
};
